import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'reducers/store'

export const getSelectedDefaultKBQItems = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedBrand
}
export const getDonutViewByItems = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.donutViewByItems
}
export const getSelectedDefaultRetailerKBQItems = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedRetailer
}

export const getSelectedDefaultChannelVisited = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedChannelVisited
}

export const getSelectedDropdownMode = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedDropdownMode
}
export const getPrimarySuffixLabel = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.primarySuffixLabel
}
const getSelectedId = (_: any, props: { id: string }) => {
  return props.id
}

export const getAllSelectedTopic = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedTopic
}

export const getSelectedTopic = createSelector(
  [getAllSelectedTopic, getSelectedId],
  (selected, id) => {
    return selected.find((s) => s.id === id)?.defaultTopic
  }
)

export const getAllSelectedNps = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedNps
}

export const getSummaries = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.summary
}

export const generateSummary = (state: Pick<RootState, 'KBQ'>) => {
  return !!state.KBQ.summary?.generateSummary
}

export const getSelectedNps = createSelector([getAllSelectedNps, getSelectedId], (selected, id) => {
  return selected.find((s) => s.id === id)?.defaultNps
})

const getSelectedLostShopperById = (_: any, props: { id: string }) => {
  return props.id
}
export const getSelectedDefaultKBQBrands = createSelector(
  [getSelectedDefaultKBQItems, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getSelectedDefaultKBQChannelVisited = createSelector(
  [getSelectedDefaultChannelVisited, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)

export const getSelectedPrimarySuffixLabel = createSelector(
  [getPrimarySuffixLabel, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getSelectedDefaultKBQPurchasedRetailers = createSelector(
  [getSelectedDefaultRetailerKBQItems, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getSelectedDefaultDropdownMode = createSelector(
  [getSelectedDropdownMode, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getKBQTopTopics = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.topTopicsNPS
}
export const getTopTopicsinNPS = createSelector(
  [getKBQTopTopics, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)

export const getSelectedKBQLostShopper = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectLostShoppers
}

export const getKBQTopLostShopper = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.topLostShoppers
}

export const getDefaultSelectedKBQLostShopper = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.defaultSelectedLostShopper
}

export const getSelectedKBQLostShopperById = createSelector(
  [getSelectedKBQLostShopper, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getSelectedKBQLostShopperByIdWithLabel = createSelector(
  [getSelectedKBQLostShopper, getSelectedLostShopperById],
  (selected, id) => {
    return selected
      .filter((s) => s.id === id)
      .map((x) => {
        return {
          variable_id: x.localFilters[0].variable_id,
          answer_code: x.localFilters[0].answer_code,
          label: x.localFilters[0].label,
          answer_id: x.localFilters[0].answer_id,
        }
      })[0]
  }
)

export const getDefaultKBQLostShopperById = createSelector(
  [getDefaultSelectedKBQLostShopper, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)

export const getTopLostShoppersById = createSelector(
  [getKBQTopLostShopper, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getSelectedPurchaseDriversViewByItems = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.selectedPurchaseDriversList
}

const getSelectedPurchaseDriversViewById = (_: any, props: { id: string }) => {
  return props.id
}

export const getSelectedPurchaseDriversItemById = createSelector(
  [getSelectedPurchaseDriversViewByItems, getSelectedPurchaseDriversViewById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)

export const getStoriesSummaryError = (state: Pick<RootState, 'KBQ'>) =>
  state.KBQ.storiesSummaryError
export const getTopPurchasedBrandDonut = (state: RootState) => state.KBQ.topPurchasedBrandDonut

export const getTopPurchasedData = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.kbqTopPurchasedData
}
export const getTopPurchasedDataById = createSelector(
  [getTopPurchasedData, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
export const getKBQChartData = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.kbqChartData
}

export const getKBQChartDataById = createSelector(
  [getKBQChartData, getSelectedLostShopperById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
const getSelectedPanelStateById = (_: any, props: { id: string }) => {
  return props.id
}

export const getKBQPanelState = (state: Pick<RootState, 'KBQ'>) => {
  return state.KBQ.accordionPanels
}

export const getKBQPanelStateById = createSelector(
  [getKBQPanelState, getSelectedPanelStateById],
  (selected, id) => {
    return selected.find((s) => s.id === id)
  }
)
